import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import { Menu, Dropdown, Typography, Space, Row, Col } from "antd";
import ReactToPrint from "react-to-print";
import { render } from "react-dom";

interface Props {
  ComponentRef?: any;
  title?: string;
  dataOpdPrint?: any;
  type?: string;
}

const PrintForSale: React.FC<Props> = ({
  ComponentRef,
  title,
  dataOpdPrint,
  type,
}) => {
  const componentRef = useRef<any>(ComponentRef);
  const { Text } = Typography;
  return (
    <div>
      <ReactToPrint
        trigger={() => (
          <a href="#" style={{ textDecoration: "none", color: "#323C47" }}>
            {title}
          </a>
        )}
        content={() => componentRef.current}
        bodyClass="print-custom"
        pageStyle="@page {size: A5 portrait;}" //
      />
      {type === "forSale" && (
        <>
          <div ref={componentRef} className="page-print-custom">
            <Row style={{ padding: "20px" }}>
              <Col span={24} className="title">
                <Text style={{ fontSize: "12px" }} strong>
                  {dataOpdPrint?.code}
                </Text>
                <br />
                <Text style={{ fontSize: "12px" }} strong>
                  {dataOpdPrint?.name}
                </Text>
              </Col>
            </Row>
            <Row className="detail-print" style={{ padding: "20px" }}>
              <Col span={12}>
                <Text style={{ fontSize: "12px" }}>
                  เพศ (Gender){" "}
                  {dataOpdPrint?.gender === "Female"
                    ? "หญิง/ Female"
                    : "ชาย/ Male"}
                </Text>
              </Col>
              <Col span={12}>
                <Text style={{ fontSize: "12px" }}>
                  อายุ (Age) {dataOpdPrint?.age}
                </Text>
              </Col>
              <Text style={{ fontSize: "12px" }}>{dataOpdPrint?.address}</Text>
            </Row>
          </div>
        </>
      )}

      {type === "OR&Anti" && (
        <>
          <div ref={componentRef} className="page-print-custom">
            <Row style={{ padding: "20px" }}>
              <Col span={24} className="title">
                <Text style={{ fontSize: "12px" }}>{dataOpdPrint?.code}</Text>
                <br />
                <Text style={{ fontSize: "12px" }}>{dataOpdPrint?.name}</Text>
              </Col>
            </Row>
            <Row style={{ padding: "20px" }}>
              <Col span={24}>
                <Text style={{ fontSize: "12px" }}>
                  เพศ (Gender){" "}
                  {dataOpdPrint?.gender === "Female"
                    ? "หญิง/ Female"
                    : "ชาย/ Male"}{" "}
                  <br /> อายุ (Age) {dataOpdPrint?.age}
                </Text>
              </Col>
            </Row>
          </div>
        </>
      )}
    </div>
  );
};

export default PrintForSale;
